var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.session && _vm.session.testmode)?_c('div',{staticClass:"fixed top-0 left-0 overflow-hidden w-[100px] h-[100px] text-right z-[999999]"},[_c('span',{staticClass:"text-sm font-bold text-white uppercase text-center leading-tight -rotate-45 w-[140px] block bg-markencode-blue shadow-md absolute top-[29px] -left-[31px]"},[_vm._v("TEST")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }